import { Component, OnInit, HostListener, DoCheck } from '@angular/core';
// import { AuthService } from '@app/service/auth.service';
import { AuthService } from '../app/core/service/auth.service';
import { environment } from '../environments/environment';
import { AlertsService } from '../app/shared/service/alerts.service';
import { SocketService } from '../app/shared/service/socket.service';
// import { ConnectionService } from 'ng-connection-service';

declare var $;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent 
{
  title = 'Excise Bengal';
  validNavigation = 0;
  isConnected=true;

  @HostListener("window:beforeunload", ["$event"])
  unloadNotification($event: any) 
  {
    this.disconnectSocket($event);
  }

  constructor(private socket: SocketService, private alert: AlertsService,private service: AuthService,  
    // private connectionService: ConnectionService
  )
  {
    if (this.validNavigation==0)
    {
      this.checkLogin()
    }

    // this.connectionService.monitor().subscribe(isConnected=>
    // {
    //   this.isConnected = isConnected
    //   if (this.isConnected)
    //   {
    //     this.alert.showToast('Internet connection is back','success' )
    //   }
    //   else
    //   {
    //     this.alert.showToast('Internet connection is lost','error' )
    //   }
    // })

  }

  ngOnInit(): void
  {
    if (this.validNavigation == 0) {
      this.checkLogin()
    }
  }

  ngDoCheck(): void 
  {
    if (this.validNavigation == 0) 
    {
      this.checkLogin()
    }
  }

  checkLogin()
  {
    this.validNavigation = 1;

    if (localStorage.getItem(environment.tokenKey))
    {
      var tokn = JSON.parse(atob((localStorage.getItem(environment.tokenKey)).split('.')[1])).token;
      tokn["iat"] = JSON.parse(atob((localStorage.getItem(environment.tokenKey)).split('.')[1])).iat;
      this.socket.connectSocket(tokn);
      this.socket.getSocketID()
    }
  }

  disconnectSocket(e)
  {
    var token = localStorage.getItem(environment.tokenKey);;
    if (token)
    {
      localStorage.setItem("lastRefreshTime",new Date().getTime().toString())
      this.socket.disconnectSocket("refresh")
    }
  }

}

